import { render, staticRenderFns } from "./message-alert-form.vue?vue&type=template&id=69e55151&"
import script from "./message-alert-form.vue?vue&type=script&lang=ts&"
export * from "./message-alert-form.vue?vue&type=script&lang=ts&"
import style0 from "./message-alert-form.vue?vue&type=style&index=0&id=69e55151&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports